/**
 * useInitData - Load shared + instance data once on app init
 *
 * Following "Simplicity First" pattern:
 * - Load once on mount
 * - Access directly with optional chaining
 * - No fallback chains, no complex detection logic
 *
 * Usage:
 * const { shared, instance, clientConfig, loading, error } = useInitData(instanceId);
 *
 * // Get variable description
 * const description = shared?.scenarios?.ilmasto?.variables?.['keskilämpötilan muutos'];
 */

import { useState, useEffect } from 'react';
import API_ENDPOINTS from '../config/api';

export function useInitData(instanceId) {
  const [data, setData] = useState({ shared: null, instance: null, clientConfig: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInitData = async () => {
      try {
        const response = await fetch(API_ENDPOINTS.INIT(instanceId));
        if (!response.ok) {
          throw new Error(`Init failed: ${response.status}`);
        }
        const result = await response.json();
        setData(result);
        setError(null);
      } catch (err) {
        console.error('Failed to load init data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInitData();
  }, [instanceId]);

  return {
    shared: data.shared,
    instance: data.instance,
    clientConfig: data.clientConfig,
    loading,
    error
  };
}

export default useInitData;
